import API from './api';

export default {
  getAllEmailCampaigns(partial = {}) {
    return API.get('/api/email-campaign/campaigns', { params: partial });
  },
  getEmailCampaignById(id) {
    return API.get(`/api/email-campaign/campaigns/${id}`);
  },
  createEmailCampaign(campaign) {
    return API.post('/api/email-campaign/campaigns', campaign);
  },
  updateEmailCampaign(id, campaign) {
    return API.put(`/api/email-campaign/campaigns/${id}`, campaign);
  },
  deleteEmailCampaign(id) {
    return API.delete(`/api/email-campaign/campaigns/${id}`);
  },
  getAllEmailCampaignSteps(partial = {}) {
    return API.get(`/api/email-campaign/steps`, { params: partial });
  },
  getEmailCampaignStepById(id) {
    return API.get(`/api/email-campaign/steps/${id}`);
  },
  createEmailCampaignStep(step) {
    return API.post('/api/email-campaign/steps', step);
  },
  updateEmailCampaignStep(id, step) {
    return API.put(`/api/email-campaign/steps/${id}`, step);
  },
  deleteEmailCampaignStep(id) {
    return API.delete(`/api/email-campaign/steps/${id}`);
  },
  sendTestEmail(payload) {
    return API.post('/api/email-campaign/test-email', payload);
  },
};
